import { NgModule } from '@angular/core';
import { ListsAndSegmentsDataSourceByDbIdPipe } from './listsAndSegmentsDataSourceByDbId.pipe';
import { RecipientsDataSourceByAgentDbIdsPipe } from './recipientsDataSourceByAgentDbIds.pipe';

@NgModule({
  declarations: [ListsAndSegmentsDataSourceByDbIdPipe, RecipientsDataSourceByAgentDbIdsPipe],
  exports: [ListsAndSegmentsDataSourceByDbIdPipe, RecipientsDataSourceByAgentDbIdsPipe],
})
export class DynamicListsAndSegmentsPipesModule {}
